/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartialResultFieldEnum } from '../../models/partial-result-field-enum';
import { SearchResult } from '../../models/search-result';

export interface GetResult$Params {

/**
 * search term
 */
  q?: string;

/**
 * advanced query
 */
  aq?: string;
  sn?: string;
  scope?: string;
  sb?: string;

/**
 * filter settings
 */
  fil?: string;
  at?: string;

/**
 * current locale
 */
  locale?: string;

/**
 * disable auto correction for this term
 */
  disableAutoCorrect?: string;

/**
 * testing mode enabled (true/false)
 */
  searchTesting?: string;

/**
 * page size
 */
  ps?: number;

/**
 * page number
 */
  pg?: number;

/**
 * list of fields to exclude from result
 */
  excludeFields?: Array<PartialResultFieldEnum>;

/**
 * used to indicate whether this was a first load or not (used for analytics only)
 */
  firstLoad?: boolean;
}

export function getResult(http: HttpClient, rootUrl: string, params?: GetResult$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResult>> {
  const rb = new RequestBuilder(rootUrl, getResult.PATH, 'get');
  if (params) {
    rb.query('q', params.q, {});
    rb.query('aq', params.aq, {});
    rb.query('sn', params.sn, {});
    rb.query('scope', params.scope, {});
    rb.query('sb', params.sb, {});
    rb.query('fil', params.fil, {});
    rb.query('at', params.at, {});
    rb.query('locale', params.locale, {});
    rb.query('disableAutoCorrect', params.disableAutoCorrect, {});
    rb.query('searchTesting', params.searchTesting, {});
    rb.query('ps', params.ps, {});
    rb.query('pg', params.pg, {});
    rb.query('excludeFields', params.excludeFields, {});
    rb.query('firstLoad', params.firstLoad, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchResult>;
    })
  );
}

getResult.PATH = '/api/results';
